// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import Adult from '../_raw/service/icon_adult.svg';
import withIconProps from '../withIconProps';

export default withIconProps(Adult);
